import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { User } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function ProfileIconLink() {
  const { profile, signOut } = useAuth();
  const navigate = useNavigate();
  const avatarUrl = profile?.avatar_url ?? null;
  const initials =
    (profile?.first_name?.[0] || "") + (profile?.last_name?.[0] || "");

  const handleProfileClick = () => {
    navigate("/client-profile");
  };

  const handleLogoutClick = async () => {
    await signOut();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          aria-label="Open profile menu"
          className="bg-white/10 rounded-full h-10 w-10 flex items-center justify-center p-0 hover:bg-white/20"
        >
          {avatarUrl ? (
            <Avatar className="h-8 w-8">
              <AvatarImage src={avatarUrl} alt="Profile" />
              <AvatarFallback>{initials || <User className="h-4 w-4" />}</AvatarFallback>
            </Avatar>
          ) : (
            <User className="w-5 h-5" />
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-dark-card border-primary/20 text-white">
        <DropdownMenuItem onClick={handleProfileClick}>
          Profile
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={handleLogoutClick}
          className="text-destructive focus:text-destructive"
        >
          Log out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}


